(() => {
  const menus=[...document.querySelectorAll('mobile-menu')];
  if(!menus.length)return;
  customElements.whenDefined('mobile-sliderule').then(()=>{
    const prototype=customElements.get('mobile-sliderule').prototype;
    const original=prototype.adjustMenuHeight;
    prototype.adjustMenuHeight=function(){
      if(!this.closest('mobile-menu')||!this.menuBlock)return original.call(this);
      const panel=this.menuBlock.querySelector('[data-sliderule="2"].is-visible')||this.menuBlock.querySelector('[data-sliderule="1"].is-visible')||this.menuBlock;
      const links=panel.querySelector('[data-links]');
      if(!links)return;
      const offset=links.getBoundingClientRect().top-this.menuBlock.getBoundingClientRect().top;
      const padding=parseFloat(getComputedStyle(this.menuBlock).paddingBottom)||0;
      this.menuBlock.style.setProperty('--block-height',`${Math.ceil(links.scrollHeight+offset+padding)}px`);
    };
    let frame;
    const resize=()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(()=>menus.forEach(menu=>menu.querySelector('mobile-sliderule')?.adjustMenuHeight()));};
    window.addEventListener('resize',resize,{passive:true});
    document.fonts?.ready.then(resize);
    resize();
  });
  customElements.whenDefined('header-search-popdown').then(()=>{
    document.querySelectorAll('header-search-popdown').forEach(search=>{
      search.addEventListener('keyup',event=>{
        if(event.code!=='Escape'||!search.classList.contains('is-open'))return;
        event.stopImmediatePropagation();search.close();
      },true);
      search.querySelector('[data-popdown]')?.addEventListener('transitionend',event=>{
        if(event.target!==search.querySelector('[data-popdown]')||event.propertyName!=='opacity'||search.classList.contains('is-open'))return;
        const summary=search.querySelector('summary');
        const drawer=search.closest('header-drawer.is-open');
        if(drawer&&window.theme?.a11y){window.theme.a11y.trapFocus(drawer.querySelector('[data-drawer-inner]'),{elementToFocus:summary});}
        else if(!search.closest('mobile-menu'))summary?.focus({preventScroll:true});
      });
    });
  });
})();
